<template>
  <el-dialog
    id="changePasswordModal"
    :title="$t('settings.changePassword')"
    :visible.sync="showLocal"
    :width="dialogWidth"
  >
    <el-form
      ref="passwordForm"
      :model="passwordForm"
      :rules="rules"
    >
      <el-form-item
        :label="$t('settings.oldPw')"
        prop="oldPassword"
      >
        <el-input
          v-model="passwordForm.oldPassword"
          autocomplete="off"
          show-password
        />
      </el-form-item>
      <el-form-item
        :label="$t('settings.newPw')"
        prop="newPassword"
      >
        <el-input
          v-model="passwordForm.newPassword"
          autocomplete="off"
          show-password
        />
      </el-form-item>
      <el-form-item
        :label="$t('settings.confirmNewPw')"
        prop="newPasswordConfirmation"
      >
        <el-input
          v-model="passwordForm.newPasswordConfirmation"
          autocomplete="off"
          show-password
        />
      </el-form-item>
    </el-form>

    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        round
        @click="showLocal = false"
      >
        {{ $t('common.cancel') }}
      </el-button>
      <el-button
        type="primary"
        round
        @click="submitNewPassword"
      >
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import api from '@/api';
import dialog from '@/mixins/dialog';

export default {
  mixins: [dialog],

  data() {
    return {
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        newPasswordConfirmation: '',
      },
      rules: {
        oldPassword: [
          { required: true, message: `${this.$t('common.rule.password.requiredOld')}`, trigger: 'blur' },
        ],
        newPassword: [
          { required: true, message: `${this.$t('common.rule.password.requiredNew')}`, trigger: 'blur' },
          { min: 8, message: `${this.$t('common.rule.password.pwMinChar8')}`, trigger: 'blur' },
          { validator: this.checkPasswordForm, trigger: 'blur' },
        ],
        newPasswordConfirmation: [
          { required: true, message: `${this.$t('common.rule.password.requiredConfirm')}`, trigger: 'blur' },
          { validator: this.checkPasswordConfirmation, trigger: ['blur', 'change'] },
        ],
      },
    };
  },

  computed: {
    showLocal: {
      get() {
        return this.show;
      },
      set(newValue) {
        if (!newValue) {
          this.$refs.passwordForm.resetFields();
        }
        this.$emit('update:show', newValue);
      },
    },
  },

  methods: {
    checkPasswordForm(rule, value, callback) {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!";#$%&'()*+,./:<=>?@[^_`{|}\-\]~])[A-Za-z\d!";#$%&'()*+,./:<=>?@[^_`{|}\-\]~]{8,}$/;

      if (!regex.test(value)) {
        callback(new Error(this.$t('common.rule.password.pwStructure')));
      } else {
        callback();
      }
    },

    checkPasswordConfirmation(rule, value, callback) {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error(this.$t('common.rule.password.pwUnmatched')));
      } else {
        callback();
      }
    },

    async submitNewPassword() {
      this.$refs.passwordForm.validate(async (valid) => {
        if (valid) {
          try {
            await api.updateINGPassword({
              old_password: this.passwordForm.oldPassword,
              new_password: this.passwordForm.newPassword,
            });
            this.$message.success(this.$t('settings.alert.pwReset'));
            this.showLocal = false;
          } catch (err) {
            console.log(err);
            if (err.msg) {
              this.$message.error(err.msg);
            }
          }
          return true;
        }
        return false;
      });
    },
  },
};
</script>

<style lang="scss">
#changePasswordModal {
  .el-input {
    input {
      border-radius: 0;
      border-top-width: 0;
      border-left-width: 0;
      border-right-width: 0;
      padding-left: 0;
    }
  }

  .dialog-footer {
    text-align: center;

    .el-button {
      width: 47%;
    }
  }

  .el-dialog {
    // height: calc(var(--vh, 1vh) * 64);
    // min-height: 200px;
    max-width: 400px;
    overflow: hidden;

    .el-dialog__body {
      // height: 100%;
      padding: 10px 0 10px 20px;

      .el-form {
        padding: 5px 20px 5px 0;
        box-sizing: border-box;
        overflow: auto;
        width: 100%;
        // height: calc(100% - 115px);

        .el-select {
          width: 100%;
        }
      }
    }

    .el-dialog__footer {
      text-align: center;
      width: 100%;
      padding: 10px 20px 30px;
      box-sizing: border-box;
      margin: 0;
      z-index: 2005;
      background: white;

      .dialog-footer {
        display: flex;
        width: 100%;
        justify-content: space-between;
      }
    }
  }
}
</style>
